import { SessionProvider } from '../../core/providers/SessionProvider.jsx';
import { ThemeProvider } from '../../core/providers/ThemeProvider.jsx';
import { LanguageProvider } from '../../core/providers/LanguageProvider.jsx';
import { PermissionProvider } from '../../core/providers/PermissionProvider.jsx';
import { AppRouter } from '../router/AppRouter.jsx';

import { getToken , onMessage} from "firebase/messaging";
import { messaging } from "../../AssetsM/firebase.js";

import ErrorBoundary from '../../AssetsM/ErrorBoundary.js';

// /*CSS*/
import 'bootstrap-icons/font/bootstrap-icons.css';
 
import "gridjs/dist/theme/mermaid.css";
import 'react-toastify/dist/ReactToastify.css';

/**
 * Bootstrap.jsx
 *
 * THE single place responsible for turning a raw login response into
 * a fully running application. Nothing else in the app is allowed to
 * read `session.system.*` directly and reinterpret it — Bootstrap
 * reads it once and hands each piece to the provider that owns it.
 *
 * Pipeline (mirrors the required architecture 1:1):
 *
 *   1. Loading session         -> `session` prop (already loaded by App.jsx)
 *   2. Reading configuration   -> `session.system`
 *   3. Loading theme           -> <ThemeProvider>
 *   4. Loading layout          -> handled inside <AppRouter>'s <MainLayout>
 *   5. Loading enabled modules -> <PermissionProvider>
 *   6. Loading routes          -> <AppRouter>
 *   7. Loading sidebar         -> <Sidebar> (reads PermissionProvider, rendered by MainLayout)
 *   8. Rendering application   -> final JSX returned below
 *
 * No `if (systemId === 'doctor')` branch exists anywhere in this file
 * or anywhere downstream — every step only ever reads generic fields
 * off the `system` object.
 */
export function Bootstrap({ session, onLogout }) {
  // Step 1 & 2: session + configuration are already available as props.
  const { system } = session;

  return (
    <ErrorBoundary>
    { /* // Step 6/8 context: session data available app-wide (user info, logout). */}
    <SessionProvider session={session} onLogout={onLogout}>
      {/* Step 3: theme loaded from system.theme + system.title */}
      <ThemeProvider theme={system.theme} title={system.title}>
        {/* Step: language provider prepared (not translated) */}
        <LanguageProvider initialLanguage={system.language}>
          {/* Step 5: enabled modules become the permission surface */}
          <PermissionProvider enabledModules={system.modules}>
            {/* Step 4, 6, 7: layout + routes + sidebar, all generated */}
            <AppRouter systemId={system.id} enabledModules={system.modules} />
          </PermissionProvider>
        </LanguageProvider>
      </ThemeProvider>
    </SessionProvider>
    </ErrorBoundary>
  );
}
